/**
 * Create By jini
 * @since 2020-01-07
 * */
import {CmApiPrefix as cmApiPrefix} from '~/utils/restApi'
import {formatDate} from '~/utils/date'
import Moment from 'moment'
import {getCodeJsonRow} from '~/utils/device-common'

export const state = () => ({
  apiUrl: {
    onlineUpdateStatus: `${cmApiPrefix}/contents/update`, // 날짜 별 패치 내역 device_contents_update_db_type : 2
    onlineUpdateDevice: `${cmApiPrefix}/contents/update/device`, // 날짜 별 패치 내역 { 장비 ID , type }
    onlineAutoUpdateConfig: `${cmApiPrefix}/contents/update/auto`, // auto Update Config device_contents_update_db_type : 2
    onlineAutoUpdateCancelConfig: `${cmApiPrefix}/contents/update/cancel`, // auto Update cancel Config
    onlineAutoUpdateApply: `${cmApiPrefix}/contents/update/apply` // apply Execute
  },
  patchHistoryList: [], // 날짜 별 패치 내역
  patchDetailInfoList: [], // 날짜 별 상세 패치 내역
  devicePatchHistoryList: [], // 장비 별 패치 내역
  deviceDetailInfoList: [], // 장비 별 상세 패치 내역
  updateType: { // 'FILE' or 'ONLINE'
    type: 'FILE'
  },
  // 패치 작업 추가 관련
  deviceIdList: [], // 패치 작업 대상 장비 리스트
  upLoadFile: null,
  errorMessage: null,
  onlineUrl: '',
  detailResultList: [],

  applicationDbType: 2, // 애플리케이션 DB Type 2로 고정
  autoUpdateConfig: {
    enable: 0, // AutoUpdate 사용 여부 0:사용 안함, 1: 사용함
    url: '', // 업데이트 서버 주소
    daysStr: [0, 0, 0, 0, 0, 0, 0], // 일월화수목금토 0:미체크, 1:체크
    deviceList: [], // 자동 업데이트 장비 리스트
    deviceListName: '', // 대상 장비 이름
    hourMin: Moment('0000', 'Hmm').format(),
    hour: '0',
    min: '0'
  }
})

export const mutations = {
  setOptions (state) {
    state.detailResultList = _.map(getCodeJsonRow('application_db_type'), (item) => {
      return { value: item.key, label: item.val }
    })
  },
  setPatchHistoryList (state, data) {
    state.patchHistoryList = _.cloneDeep(data)
  },
  setAutoUpdateConfig (state, data) {
    const item = _.cloneDeep(data)
    /*
    item = {
      contents_auto_update_yn: 1, // AutoUpdate 사용 여부 0:사용 안함, 1: 사용함
      contents_update_server: 'welcome to jiniworld', // 서버 주소
      contents_update_week: [0, 1, 0, 0, 1, 0, 0], // 일월화수목금토
      contents_update_date: '13:00', // 시:분
      contents_device_id_list: [5] // 장비 ID 리스트
      contents_device_uname: 'select item name'
    }
     */
    const config = {}
    config.enable = item.contents_auto_update_yn
    config.url = item.contents_update_server
    if (item.contents_update_week.length > 0) {
      const temp = _.toArray(item.contents_update_week)
      const arr = []
      temp.forEach((v) => {
        arr.push(parseInt(v))
      })
      config.daysStr = arr
    } else {
      config.daysStr = [0, 0, 0, 0, 0, 0, 0]
    }
    config.hour = (item.contents_update_date.indexOf(':') > -1) ? item.contents_update_date.split(':')[0] : '0'
    config.min = (item.contents_update_date.indexOf(':') > -1) ? item.contents_update_date.split(':')[1] : '0'
    if (item.contents_update_date.indexOf(':') > -1) {
      config.hourMin = Moment().set('hour', Number(config.hour)).set('minute', Number(config.min)).format()
    } else {
      // Blank
      config.hourMin = Moment('0000', 'Hmm').format()
    }
    config.deviceList = item.contents_device_id_list
    config.deviceListName = item.contents_device_uname

    state.autoUpdateConfig = _.cloneDeep(config)
  },
  setPatchHistoryDetailList () {
  },
  setPatchDetailInfo (state, data) {
    const item = _.cloneDeep(data)
    state.patchDetailInfoList = item
  },
  setDevicePatchHistoryList (state, data) {
    state.devicePatchHistoryList = _.cloneDeep(data)
  },
  setDevicePatchDetailInfo (state, data) {
    const item = _.cloneDeep(data)
    state.deviceDetailInfoList = item
  },
  clearPatchHistoryData (state) {
    state.patchHistoryList = [] // 날짜 별 패치 내역
    state.patchDetailInfoList = [] // 날짜 별 상세 패치 내역
    state.devicePatchHistoryList = [] // 장비 별 패치 내역
    state.deviceDetailInfoList = [] // 장비 별 상세 패치 내역
    state.detailResultList = []
  },
  setPatchDeviceData (state, data) {
    state.deviceIdList = _.cloneDeep(data)
  },
  setPatchDataUrl () {
  },
  clearPatchDeviceData (state) {
    state.updateType = {
      type: 'FILE'
    }
    state.deviceIdList = []
    state.onlineUrl = ''
    // state.upLoadFile = null
  },
  setErrorMessage (state, data) {
    state.errorMessage = data.msg || ''
  },
  setFileUpload (state, data) {
    state.upLoadFile = data
  }
  // Mutation End
}

export const actions = {
  async getPatchHistoryList ({commit, state}) {
    const obj = {
      device_contents_update_db_type: state.applicationDbType
    }
    const {code, result} = await this.$axios.$get(state.apiUrl.onlineUpdateStatus, {params: obj})
    if (code === 'ok') {
      commit('setPatchHistoryList', result)
    }
  },
  async getPatchHistoryDetailList ({commit, state}, {deviceId}) {
    // 날짜 별 상세 정보
    // /api/cm/contents/update/1?device_contents_update_db_type=2'
    // state.apiUrl.onlineUpdateStatus   contents/update

    let url = state.apiUrl.onlineUpdateStatus
    url += `/${deviceId}`

    const param = {
      device_contents_update_db_type: state.applicationDbType
    }

    const {code, result} = await this.$axios.$get(url, {params: param})
    if (code === 'ok') {
      commit('setPatchDetailInfo', result)
    }
  },
  async getDevicePatchHistoryDetailList ({commit, state}, {deviceId}) {
    // 장비 별 상세 정보
    // /api/cm/contents/update/device/1?device_contents_update_db_type=2'
    // state.apiUrl.onlineUpdateDevice   contents/update/device
    let url = state.apiUrl.onlineUpdateDevice
    url += `/${deviceId}`

    const param = {
      device_contents_update_db_type: state.applicationDbType
    }

    const {code, result} = await this.$axios.$get(url, {params: param})
    if (code === 'ok') {
      commit('setDevicePatchDetailInfo', result)
    }
  },
  async getDevicePatchHistoryList ({commit, state}) {
    // 장비 별 정보
    // /api/cm/contents/update/device?device_contents_update_db_type=2
    // state.apiUrl.onlineUpdateDevice   contents/update/device
    const param = {
      device_contents_update_db_type: state.applicationDbType
    }
    const {code, result} = await this.$axios.$get(state.apiUrl.onlineUpdateDevice, {params: param})
    if (code === 'ok') {
      commit('setDevicePatchHistoryList', result)
    }
  },
  async getAutoUpdateConfig ({commit, state}) {
    // 자동 업데이트 설정 정보
    // /api/cm/contents/update/auto?device_contents_update_db_type=2
    // state.apiUrl.onlineAutoUpdateConfig   contents/update/auto
    const param = {
      device_contents_update_db_type: state.applicationDbType
    }
    const {code, result} = await this.$axios.$get(state.apiUrl.onlineAutoUpdateConfig, {params: param})
    if (code === 'ok') {
      commit('setAutoUpdateConfig', result)
    }
  },
  async parseTimeData ({commit, state}, data) {
    state.autoUpdateConfig.hour = formatDate(data, 'HH')
    state.autoUpdateConfig.min = formatDate(data, 'mm')
  },
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      const params = {}
      let url = ''
      if (type === 'apply') {
        msg = {applyMsg: true, loading: false}
        params.contents_auto_update_yn = state.autoUpdateConfig.enable
        params.contents_update_server = state.autoUpdateConfig.url
        const arr = state.autoUpdateConfig.daysStr
        let dayStr = ''
        arr.forEach((v) => {
          dayStr += '' + v
        })
        params.contents_update_week = dayStr
        params.contents_update_date = state.autoUpdateConfig.hour.concat(':').concat(state.autoUpdateConfig.min)
        params.contents_device_id_list = state.autoUpdateConfig.deviceList

        url = state.apiUrl.onlineAutoUpdateConfig + '?device_contents_update_db_type=' + state.applicationDbType
      } else {
        msg = {cancelMsg: true, loading: false}
        url = state.apiUrl.onlineAutoUpdateCancelConfig
      }
      const data = await this.$axios.$put(url, (type === 'apply' ? params : null), msg)

      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async setDevicePatchData ({commit, state}) {
    //
    let data = { code: 'nok', result: { msg: `Unknown Update Type: ${state.updateType.type}` } }

    const url = state.apiUrl.onlineUpdateStatus + '?device_contents_update_db_type=' + state.applicationDbType
    const formData = new FormData()
    formData.append('device_id_list', JSON.stringify(state.deviceIdList))

    if (state.updateType.type === 'FILE') {
      formData.append('device_contents_update_type', 1) // 1: File, 2:TAMS
      formData.append('device_contents_update_file_name', state.upLoadFile.formData.get('file'))

      data = await this.$axios.$put(url, formData)
    } else if (state.updateType.type === 'ONLINE') {
      formData.append('device_contents_update_type', 2) // 1: File, 2:TAMS
      formData.append('device_contents_update_server', state.onlineUrl)

      data = await this.$axios.$put(url, formData)
    }

    if (data.code === 'ok') {
      return true
    } else {
      commit('setErrorMessage', data.result)
      return false
    }
  },

  setUrlInputHandler ({commit, state}, value) {
    state.onlineUrl = value
  },

  async setApplyExecute ({state}) {
    try {
      const result = await this.$axios.$put(state.apiUrl.onlineAutoUpdateApply)
      if (result.code === 'ok') {
        return result
      }
    } catch (error) {
      return {code: 'error', errors: error}
    }
  }
  // action End
}

export const getters = {}
